import { apiHelper } from "./core"

const userServiceBaseUrl = process.env.REACT_APP_USER_MANAGEMENT_BASE_URL
const clinicalServiceBaseUrl =
  process.env.REACT_APP_CLINICAL_MANAGEMENT_BASE_URL
const resourceServiceBaseUrl =
  process.env.REACT_APP_RESOURCE_MANAGEMENT_BASE_URL
const masterServiceBaseUrl = process.env.REACT_APP_MASTER_BASE_URL
const reportingServiceBaseUrl = process.env.REACT_APP_REPORTING_BASE_URL

const getQualityIndicatorData = (id: any, month: any, year: any): Promise<any> => {
  return apiHelper
    .get(`${reportingServiceBaseUrl}/quality?centerId=${id}&month=${month}&year=${year}`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const saveQualityIndicator = (values: any): Promise<any> => {
  return apiHelper
    .post(`${reportingServiceBaseUrl}/quality`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const updateQualityIndicator = (values: any, id: any): Promise<any> => {
  return apiHelper
    .put(`${reportingServiceBaseUrl}/quality/${id}`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

export { saveQualityIndicator, getQualityIndicatorData, updateQualityIndicator }
